// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { StateService } from '@uirouter/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import {
    InventoryDialogsContentLinksComponent,
} from '@client/app/pages/inventory/dialogs/links/inventory-dialogs-content-links.component';
import { PagesFilesComponent } from '@client/app/components/pages/files/pages-files.component';

/**
 * Inventory document component
 * Upgraded from AngularJS component
 */
@Component({
    selector: 'inventory-document',
    templateUrl: './inventory-document.component.html',
    standalone: false,
})
export class InventoryDocumentComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    // Properties matching original component
    public types: any = {};
    public exports: any[] = [];
    public documentCollection: string[] = [];
    public domainId: string = '';
    public loading: boolean = false;

    constructor (
        private translateService: TranslateService,
        private linksRepoService: LinksRepoService,
        private stateService: StateService,
        private monEventService: MonEventService,
    ) {}

    ngOnInit (): void {
        this.initializeComponent();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeComponent (): void {
        const target = this.stateService.params['doc-target'];
        this.domainId = this.stateService.params.domainId;

        this.types = {
            pages: {
                type: 'link',
                name: this.translateService.getString('Pages'),
                icon: 'fas fa-copy',
                total: 0,
                active: 'link',
            },
            spreadsheet: {
                type: 'spreadsheet',
                name: this.translateService.getString('Spreadsheets'),
                icon: 'fas fa-file-excel',
                total: 0,
                active: 'spreadsheet',
            },
            pdf: {
                type: 'pdf',
                name: this.translateService.getString('PDF files'),
                icon: 'fas fa-file-pdf',
                total: 0,
                active: 'pdf',
            },
            zip: {
                type: 'archive',
                name: this.translateService.getString('Archive files'),
                icon: 'fas fa-file-archive',
                total: 0,
                active: 'archive',
            },
            document: {
                type: 'document',
                name: this.translateService.getString('Text documents'),
                icon: 'fas fa-file-alt',
                total: 0,
                active: 'document',
            },
            slide: {
                type: 'slide',
                name: this.translateService.getString('Slides'),
                icon: 'fas fa-file-powerpoint',
                total: 0,
                active: 'slide',
            },
            file: {
                type: 'file',
                name: this.translateService.getString('Other files'),
                icon: 'fas fa-file',
                total: 0,
                active: 'file',
            },
        };

        this.exports = [
            {
                name: this.translateService.getString('Inventory Documents Export'),
                data: {
                    category: 'inventory_documents',
                },
            },
            {
                name: this.translateService.getString('Links To Documents Export'),
                data: {
                    category: 'inventory_links_to_documents',
                },
            },
        ];

        this.documentCollection = ['link', 'spreadsheet', 'pdf', 'archive', 'document', 'slide', 'file'];

        this.getPage();
        if (target && this.documentCollection.indexOf(target) > -1) {
            this.openPages(this.types[target]);
        }
    }

    public getPage (): void {
        const promises: Promise<any>[] = [];
        this.documentCollection.forEach((documentType) => {
            promises.push(this.getLinks(documentType));
        });
        this.loading = true;

        Promise.all(promises).then((values) => {
            this.types.pages.total = values[0].total;
            this.types.spreadsheet.total = values[1].total;
            this.types.pdf.total = values[2].total;
            this.types.zip.total = values[3].total;
            this.types.document.total = values[4].total;
            this.types.slide.total = values[5].total;
            this.types.file.total = values[6].total;

            this.loading = false;
        });
    }

    private getLinks (type: string): Promise<any> {
        const params = {
            page: 1,
            page_size: 1,
            domainId: this.domainId,
            type: type,
            status: 'active',
            page_fixed: false,
        };

        return this.linksRepoService.getAll(params);
    }

    public openPages (type: any): void {
        let params: any = {};
        if (type.type === 'link') {
            params = {
                body: InventoryDialogsContentLinksComponent,
                size: 'lg',
            };
        } else {
            params = {
                body: PagesFilesComponent,
                size: 'lg',
                data: {
                    lookFor: type.active,
                    type: type,
                    domainId: this.domainId,
                    icon: type.icon,
                    status: 'active',
                },
            };
        }

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
